const MaxText = {
    id: 'MaxText',
    beforeDraw: function(chart) {
        let lineAt = chart.options.linearGradientThreshold;
        const { ctx } = chart;
        const yAxe = chart.scales.y;

        lineAt = (lineAt - yAxe.min) * (100 / yAxe.max);
        lineAt = ((100 - lineAt) / 100) * yAxe.height + yAxe.top;
        ctx.restore();
        ctx.textBaseline = 'top';
        ctx.fillStyle = '#808080';
        const text = 'Max Limit',
            textX = 0,
            textY = lineAt - 5;

        ctx.fillText(text, textX, textY);
        ctx.stroke();
        ctx.save();
    }
};

export default MaxText;
